var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location-fields"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.company.remote),
      expression: "!company.remote"
    }]
  }, [_vm._l((_vm.company.locations), function(location, index) {
    return _c('div', {
      key: location.id || index,
      staticClass: "location-field",
      model: {
        value: (_vm.company.locations),
        callback: function($$v) {
          _vm.company.locations = $$v
        },
        expression: "company.locations"
      }
    }, [(location.hq) ? [_c('locationField', {
      staticClass: "location-input hq",
      attrs: {
        "model": ("company[locations_attributes][" + index + "]"),
        "attribute": "address",
        "placeholder": "Enter your headquarters location",
        "required": !_vm.company.remote
      },
      model: {
        value: (location.address),
        callback: function($$v) {
          location.address = $$v
        },
        expression: "location.address"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.company.locations.length > 1),
        expression: "company.locations.length > 1"
      }],
      staticClass: "hq-label"
    }, [_vm._v("\n          Headquarters\n        ")])] : [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!location._destroy),
        expression: "!location._destroy"
      }]
    }, [_c('locationField', {
      staticClass: "location-input",
      attrs: {
        "model": ("company[locations_attributes][" + index + "]"),
        "attribute": "address",
        "placeholder": "Enter another location"
      },
      model: {
        value: (location.address),
        callback: function($$v) {
          location.address = $$v
        },
        expression: "location.address"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "location-controls location-controls--remove small-icon-btn"
    }, [_c('span', {
      staticClass: "ss-icon is-big"
    }, [_vm._v("minus")]), _vm._v(" "), _c('p', {
      staticClass: "remove-location",
      on: {
        "click": function($event) {
          location._destroy = 1
        }
      }
    }, [_vm._v("Remove location")])])], 1)], _vm._v(" "), _vm._l((['index', 'id', 'address', 'hq']), function(key) {
      return _c('input', {
        key: key,
        attrs: {
          "type": "hidden",
          "name": ("company[locations_attributes][" + index + "][" + key + "]")
        },
        domProps: {
          "value": location[key]
        }
      })
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": ("company[locations_attributes][" + index + "][_destroy]")
      },
      domProps: {
        "value": location._destroy || _vm.company.remote
      }
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "location-controls small-icon-btn"
  }, [_c('span', {
    staticClass: "ss-icon is-big"
  }, [_vm._v("plus")]), _vm._v(" "), _c('a', {
    staticClass: "add-location",
    on: {
      "click": _vm.addLocation
    }
  }, [_vm._v("Add another location")])]), _vm._v(" "), _c('hr', {
    staticClass: "locations_rule"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "remote-checkboxes"
  }, [_c('div', {
    staticClass: "cm-field cm-radio-field"
  }, [_c('label', {
    staticClass: "cm-label remote"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "company[remote]"
    },
    domProps: {
      "checked": _vm.company.remote
    },
    on: {
      "change": _vm.toggleRemote
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "company[remote]",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.company.remote
    }
  }), _vm._v("\n        " + _vm._s(_vm.I18n.t('activerecord.attributes.company.remote')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "cm-field cm-radio-field"
  }, [_c('label', {
    staticClass: "cm-label remote"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "company[remote_employees]"
    },
    domProps: {
      "checked": _vm.company.remote_employees
    },
    on: {
      "change": _vm.toggleRemoteEmployees
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "company[remote_employees]",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.company.remote_employees
    }
  }), _vm._v("\n        " + _vm._s(_vm.I18n.t('activerecord.attributes.company.remote_employees')) + "\n      ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf44a2e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/location-fields.vue
// module id = null
// module chunks = 